import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import AddressBooks from "@/pages/Pages/AddressBooks/AddressBooks.vue";
import AddressBook from "@/pages/Pages/AddressBooks/AddressBook.vue";
import AddressBookContacts from "@/pages/Pages/AddressBooks/AddressBookContacts.vue";
import AddressBookContact from "@/pages/Pages/AddressBooks/AddressBookContact.vue";

let addressBookMenu = {
  path: "/",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "/address_book/group",
      name: "address_book_group",
      component: AddressBooks,
      meta: {
        icon: "contact_mail",
        msgKey: 'menu.item.contacts.address.book'
      }
    },
    {
      path: "/address_book/group/new",
      name: "address_book_group_new",
      component: AddressBook,
      meta: {
        parentPath: "/address_book/group",
        msgKey: 'menu.item.contacts.address.book'
      }
    },
    {
      path: "/address_book/group/:id",
      name: "address_book_group_edit",
      component: AddressBook,
      meta: {
        parentPath: "/address_book/group",
        msgKey: 'menu.item.contacts.address.book'
      }
    },
    {
      path: "/address_book/group/:id/contact",
      name: "address_book_group_contact",
      component: AddressBookContacts,
      meta: {
        parentPath: "/address_book/group",
        msgKey: 'menu.item.contacts.address.book'
      }
    },
    {
      path: "/address_book/group/:id/contact/new",
      name: "address_book_group_contact_new",
      component: AddressBookContact,
      meta: {
        showBack: true,
        msgKey: 'menu.item.contacts.address.book'
      }
    },
    {
      path: "/address_book/group/:id/contact/:contactId",
      name: "address_book_group_contact_edit",
      component: AddressBookContact,
      meta: {
        showBack: true,
        msgKey: 'menu.item.contacts.address.book'
      }
    },
  ]
};

export default addressBookMenu;